import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { TableModule } from 'primeng/table';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TabViewModule } from 'primeng/tabview';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { CalendarModule } from 'primeng/calendar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';

import { AuthService } from 'src/app/core/auth/auth.service';
import { AuthorizationGuard } from 'src/app/core/guards/authorization.guard';
import { NotificationsService } from 'src/app/shared/notifications/notifications.service';
import { NotificationsModule } from 'src/app/shared/notifications/notifications.module';
import { SfDropDownModule } from 'src/app/shared/components/dropdown/dropdown.module';
import { LoaderModule } from 'src/app/shared/components/loader/loader.module';
import { SfSubHeaderModule } from 'src/app/shared/components/sub-header/sub-header.module';
import { SfBreadCrumbModule } from 'src/app/shared/components/sf-breadcrumb/sf-breadcrumb.module';

import { WoOrderServiceDefaultGridComponent } from './wo-order-service-default/wo-order-service-default-grid/wo-order-service-default-grid.component';
import { WoOrderServiceDefaultDetailComponent } from './wo-order-service-default/wo-order-service-default-detail/wo-order-service-default-detail.component';
import { WoOrderServiceDefaultDropdownComponent } from './wo-order-service-default/wo-order-service-default-dropdown/wo-order-service-default-dropdown.component';
import { WoOrderServiceDefaultRoutingModule } from './wo-order-service-default.routing.module';
import { WoOrderServiceDefaultService } from './wo-order-service-default/wo-order-service-default.service';

@NgModule({
    declarations: [
        WoOrderServiceDefaultGridComponent,
        WoOrderServiceDefaultDetailComponent,
        WoOrderServiceDefaultDropdownComponent
    ],
    exports: [
        WoOrderServiceDefaultDetailComponent,
        WoOrderServiceDefaultDropdownComponent
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        WoOrderServiceDefaultRoutingModule,
        ButtonModule,
        InputTextModule,
        TranslateModule,
        MessageModule,
        MessagesModule,
        TableModule,
        TooltipModule,
        ConfirmDialogModule,
        TabViewModule,
        CardModule,
        DialogModule,
        NotificationsModule,
        InputNumberModule,
        CalendarModule,
        SfDropDownModule,
        LoaderModule,
        ProgressSpinnerModule,
        DividerModule,
        SfSubHeaderModule,
        SfBreadCrumbModule,
        DropdownModule,
    ],
    providers: [
        NotificationsService,
        AuthService,
        AuthorizationGuard,
        WoOrderServiceDefaultService
    ]
})
export class WoOrderServiceDefaultModule { }

